import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { MaalerTypeRepository } from "../maaler-type/maaler-type.repository";
import { MaalerOplysninger } from "../model/maaler-oplysninger.model";
import { Maaler } from "../model/maaler.model";
import { MaalerRepository } from "./maaler.repository";

@Injectable({ providedIn: "root" })
export class MaalerService {
    constructor(private readonly maalerRepository: MaalerRepository, private readonly maalerTypeRepository: MaalerTypeRepository) {}

    public hentMaaler(ejendomNr: number, installationNr: number): Observable<Maaler> {
        return this.maalerRepository.hentMaaler(ejendomNr, installationNr);
    }

    public hentMaalerOplysninger(ejendomNr: number, installationNr: number): Observable<MaalerOplysninger> {
        const maaler$ = this.maalerRepository.hentMaaler(ejendomNr, installationNr);
        const maalerTyper$ = this.maalerTypeRepository.hentMaalerTyper();
        return combineLatest([maaler$, maalerTyper$]).pipe(
            map(([maaler, maalerTyper]) => {
                const maalerType = maalerTyper.find(t => t.id === maaler.maalerTypeNr);
                return { ...maaler, maalerType };
            })
        );
    }
}
